import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  loaderWrapper: {
    zIndex: '1101',
    top: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(142, 144, 145, 0.5)',
    position: 'absolute',
    width: '100%',
    height: '100%'
  },
  loaderItem: {
    color: theme.baseUI.color
  }
}));
